import { Component, OnInit } from '@angular/core';
import {OrganisationPreferencesService} from '../../../../_services/organisation/organisation-preferences.service';

@Component({
  selector: 'acabim-admin-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit {

  showOnboarding = false;
  setupRuns = 0;
  launchText = '';
  firstRunText = 'Get started';
  reRunText = 'Run the setup wizard again';

  constructor(
      private readonly organisationPreferencesService: OrganisationPreferencesService
  ) { }

  ngOnInit(): void {
    this.organisationPreferencesService.getSetupRuns().subscribe(data => {
      console.dir(data);
      this.setupRuns = data;
      if (this.setupRuns > 0) {
        this.launchText = this.reRunText;
      } else {
        this.launchText = this.firstRunText;
      }
    });
  }

  handleOnboardingModal(value: any): void {
    console.dir(value);
    this.showOnboarding = value;
  }

  completed(value: string): void {
    if (value === 'completed') {
      this.organisationPreferencesService.setSetupRuns().subscribe(data => {
        console.dir(data);
        this.setupRuns = data;
        if (this.setupRuns > 0) {
          this.launchText =  this.reRunText;
        }
        this.showOnboarding = false;
      });
    } else {
      this.showOnboarding = false;
    }
  }

} // EOC
